// A BARRA DE MÓDULOS QUE CABE NA TELA (05/10/2026).
//
// Num notebook de 1280px a barra do topo tinha 1052px de ícones para 646px de
// espaço: sete módulos (E-mail, Central telefônica, Financeiro, Lumos,
// Contatos…) só apareciam rolando a barra para o lado — a esposa do Victor
// não achava o menu inteiro. É o padrão "prioridade+": os ícones que cabem
// ficam à vista, na ordem de sempre, e o resto entra num "Mais" no fim. O
// módulo aberto nunca vai para o "Mais": se ele cairia lá, toma o lugar do
// último visível, para o marcador continuar mostrando onde a pessoa está.

// 40px de ícone + 6px de vão (`.advup-nav`).
export const PASSO_DO_ICONE = 46;
const VAO = 6;

export const quantosCabem = (espaco, passo = PASSO_DO_ICONE) =>
  Math.max(0, Math.floor((espaco + VAO) / passo));

// Nunca menos que isto à vista: abaixo disso a barra vira só o "Mais".
const MINIMO_VISIVEL = 3;

export const dividirBarra = (itens, cabem, ehAtivo = () => false) => {
  if (!Number.isFinite(cabem) || cabem >= itens.length) {
    return { visiveis: itens, noMais: [] };
  }
  // Um lugar fica para o próprio "Mais".
  const vagas = Math.max(MINIMO_VISIVEL, cabem - 1);
  const visiveis = itens.slice(0, vagas);
  const indiceAtivo = itens.findIndex(ehAtivo);
  if (indiceAtivo >= vagas) {
    visiveis[vagas - 1] = itens[indiceAtivo];
  }
  const noMais = itens.filter(item => !visiveis.includes(item));
  return { visiveis, noMais };
};

// OS GRUPOS DA BARRA (08/10/2026).
//
// Victor mandou a foto: "a barra é uma fila longa de ícones sem rótulo".
// Dezessete quadrados iguais em fila não dizem onde começa o atendimento e
// onde começa o jurídico — a pessoa decora posição. Os módulos passam a andar
// em grupos, com um fio entre eles na barra e um título no "Mais" e na folha
// do celular. A ordem DENTRO do grupo é a de sempre; o que mudou de lugar foi
// E-mail, Central telefônica e Contatos (conversa com gente, junto das
// Conversas) e advup Labs (ferramenta, para o fim — desligado em produção).
export const GRUPOS_DA_BARRA = [
  'inicio',
  'atendimento',
  'juridico',
  'gestao',
  'ferramentas',
];

const GRUPO_DO_MODULO = {
  LegalDashboard: 'inicio',
  Conversation: 'atendimento',
  Pipeline: 'atendimento',
  FollowUps: 'atendimento',
  InternalChat: 'atendimento',
  Correio: 'atendimento',
  CentralTelefonica: 'atendimento',
  Contacts: 'atendimento',
  Appointments: 'juridico',
  LegalProcesses: 'juridico',
  LegalClients: 'juridico',
  LegalPublications: 'juridico',
  LegalCases: 'juridico',
  LegalGed: 'juridico',
  Minutas: 'juridico',
  FinancialModule: 'gestao',
  Reports: 'gestao',
  Captain: 'gestao',
  AnaliseComerciall: 'gestao',
};

// Módulo que ninguém classificou (app instalado, módulo novo) cai em
// "Ferramentas" — nunca some da barra por falta de grupo.
export const grupoDoModulo = nome => GRUPO_DO_MODULO[nome] || 'ferramentas';

// Ordena pelos grupos sem embaralhar a ordem de dentro de cada um (`sort` é
// estável).
export const ordenarPorGrupo = itens =>
  [...itens].sort(
    (a, b) =>
      GRUPOS_DA_BARRA.indexOf(grupoDoModulo(a.name)) -
      GRUPOS_DA_BARRA.indexOf(grupoDoModulo(b.name))
  );

// Quais itens abrem um grupo novo na fila — é antes deles que a barra
// desenha o fio. O primeiro nunca abre (fio na ponta é moldura, não divisão).
export const comecosDeGrupo = itens =>
  new Set(
    itens
      .filter(
        (item, i) =>
          i > 0 && grupoDoModulo(item.name) !== grupoDoModulo(itens[i - 1].name)
      )
      .map(item => item.name)
  );

// A lista em blocos, para o "Mais" e a folha do celular: [{ grupo, itens }].
export const emBlocos = itens =>
  GRUPOS_DA_BARRA.map(grupo => ({
    grupo,
    itens: itens.filter(item => grupoDoModulo(item.name) === grupo),
  })).filter(bloco => bloco.itens.length);
